import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=4b61413c"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b61413c')) {
      api.createRecord('4b61413c', component.options)
    } else {
      api.reload('4b61413c', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=4b61413c", function () {
      api.rerender('4b61413c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/tab.vue"
export default component.exports